import {
  ALARM_PAGE_GET_DATA,
  ALARM_PAGE_GET_DETAILS_DATA,
  ALARM_PAGE_UPDATE_DATA,
} from "./Constants";

const initialState = {
  loading: false,
  error: null,
  alarmPageList: {},
  alarmPage: {},
  updateSuccess: false,
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {

    // Get all list
    case ALARM_PAGE_GET_DATA.ALARM_PAGE_GET_DATA_LOAD:
      return { 
        ...state,
        loading: true,
        alarmPageList: {},
        error: null 
      };
    case ALARM_PAGE_GET_DATA.ALARM_PAGE_GET_DATA_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        error: null, 
        alarmPageList: { data: action.alarmPageList } 
      };
    case ALARM_PAGE_GET_DATA.ALARM_PAGE_GET_DATA_FAIL:
      return { 
        ...state, 
        loading: false, 
        error: action.error 
      };

    // Get by id
    case ALARM_PAGE_GET_DETAILS_DATA.ALARM_PAGE_GET_DETAILS_DATA_LOAD:
      return { 
        ...state, 
        loading: true, 
        alarmPage: {}, 
        error: null 
      };
    case ALARM_PAGE_GET_DETAILS_DATA.ALARM_PAGE_GET_DETAILS_DATA_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        alarmPage: action.alarmPage, 
        error: null 
      };
    case ALARM_PAGE_GET_DETAILS_DATA.ALARM_PAGE_GET_DETAILS_DATA_FAIL:
      return { 
        ...state, 
        loading: false, 
        alarmPage: {}, 
        error: action.error 
      };

    // Update
    case ALARM_PAGE_UPDATE_DATA.ALARM_PAGE_UPDATE_DATA_LOAD:
      return { 
        ...state, 
        loading: true, 
        updateSuccess: false, 
        error: null };
    case ALARM_PAGE_UPDATE_DATA.ALARM_PAGE_UPDATE_DATA_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        alarmPage: action.alarmPage, 
        updateSuccess: true, 
        error: false 
      };
    case ALARM_PAGE_UPDATE_DATA.ALARM_PAGE_UPDATE_DATA_FAIL:
      return { 
        ...state, 
        loading: false, 
        updateSuccess: false, 
        error: action.error 
      };
    case ALARM_PAGE_UPDATE_DATA.ALARM_PAGE_UPDATE_DATA_RESET:
      return { 
        ...state, 
        loading: false, 
        alarmPage: {}, 
        updateSuccess: false, 
        error: null 
      };

    default:
      return { ...state };
  }
};

export default Reducer;